export default "__VITE_ASSET__Bpv8efJB__"